import Link from 'next/link'
import { Row, Col, Card, Button } from 'react-bootstrap'
import ShareIcon from '@assets/icons/share-icon-card.svg'

import Icon from '@atk/components/icon'

import styles from './CardsSection.module.scss'

export default function CardsSection() {
    const cardClass = `${styles.card} p-3 p-lg-4`

    return (
        <section className={styles.cardsSection}>
            <Row>
                <Col className="mb-lg-0 mb-4" lg={6}>
                    <Link target="_blank" href="https://docs.casperlabs.io/" className="text-decoration-none">
                        <Card className={cardClass}>
                            <Card.Body>
                                <div className="d-flex justify-content-between mb-3">
                                    <p className="h6">Documentation</p>
                                    <Icon source={ShareIcon.src} />
                                </div>
                                <p className="mb-4">Quick start guides for building or validating on Casper.</p>

                                <Button variant="link text-start">Read More</Button>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col lg={6}>
                    <Link target="_blank" href="https://arxiv.org/pdf/2101.02159.pdf" className="text-decoration-none">
                        <Card className={cardClass}>
                            <Card.Body>
                                <div className="d-flex justify-content-between mb-3">
                                    <p className="h6">White Paper</p>
                                    <Icon source={ShareIcon.src} />
                                </div>
                                <p className="mb-4">The Casper Highway Protocol paper.</p>

                                <Button variant="link text-start">Get white paper</Button>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </section>
    )
}
